import React from 'react';
import AuthStateContext from './AuthStateContext';

export default function useAuth()
{
    return React.useContext(AuthStateContext);
}